import React from 'react';

import clsx from 'clsx';

/**
 * @param root0
 * @param root0.className
 * @param root0.children
 */
const GlassCardGrid = ({ className, children }) => (
  <div className={clsx('glass-card-grid', className)}>
    <div className="glass-card-grid__inner">{children}</div>
  </div>
);

export default GlassCardGrid;
